import React from 'react';

import Store from 'store';
import Session from 'store/session';
import { BuildInfoLevel, getProfilePath } from 'common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

export function useContentCreator() {
  return Session.useSelector(state => (state.userLevel || 0) >= BuildInfoLevel);
}

export function useProfileId() {
  return Store.useSelector(store => store.imported && store.importedId);
}

export function useProfileSetId() {
  const storeid = Store.useSelector(store => store.imported && store.importedId);
  const profileid = Store.useProfile(profile => profile.imported && profile.importedId);
  const active = Store.useSelector(store => store.profiles.length > 1 ? store.activeProfile + 1 : null);

  if (profileid) return {id: profileid};
  if (storeid) return {id: storeid, set: active};
}

function copyText(text) {
  const node = document.createElement('input');
  document.body.appendChild(node);
  node.value = text;
  node.select();
  document.execCommand('copy');
  document.body.removeChild(node);
}

function EmbedLink({ text, children }) {
  const [copied, setCopied] = React.useState(false);
  const isMounted = React.useRef(true);
  React.useEffect(() => (() => isMounted.current = false), []);
  const onClick = React.useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    copyText(text);
    setCopied(true);
    setTimeout(() => isMounted.current && setCopied(false), 1000);
  }, [text]);
  return (
    <span className="d2p-EmbedLink" onClick={onClick}>
      {copied && 'Copied!'}
      {!copied && children}
      {!copied && !!children && ' '}
      {!copied && <FontAwesomeIcon icon={faLink}/>}
    </span>
  );
}

export function EmbedItemLink({ profile, id, text, children }) {
  const code = `[d2planner-item${profile ? ` profile=${profile}` : ''} id=${id}]${text}[/d2planner-item]`;
  return <EmbedLink text={code} children={children}/>;
}

export function EmbedProfileLink({ id, set, type, children }) {
  const url = new URL(getProfilePath(id), window.location);
  if (set || (type && type !== 'player')) {
    url.hash = '#' + encodeURIComponent(set || '') + '&' + encodeURIComponent(type);
  }
  return <EmbedLink text={url.href} children={children}/>
}
